import { MessageSquare, Plus } from 'lucide-react'
import { useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'
import { useCreateAgentConversation } from '../../../../../hooks/useAgentConversation'

const PROMPTS = [
  'Find ACME Trucking',
  'Create a new motor carrier',
  'Look up an application by DOT number',
  'Upload a fleet PDF and find or create the carrier',
]

export function EmptyState() {
  const navigate = useNavigate()
  const createMutation = useCreateAgentConversation()

  const handleNew = () => {
    createMutation.mutate(undefined, {
      onSuccess: (conv) => navigate(`/insure/internal/agent-chat/${conv.id}`),
    })
  }

  return (
    <div className="bg-card flex h-full flex-col items-center justify-center gap-6 rounded-lg border p-8 text-center">
      <MessageSquare className="text-muted-foreground h-12 w-12 opacity-50" />
      <div className="space-y-1">
        <div className="text-xl font-semibold">Start a conversation</div>
        <div className="text-muted-foreground text-sm">
          Ask the internal agent to search, create, or edit anything across orgs.
        </div>
      </div>
      <Button onClick={handleNew} disabled={createMutation.isPending}>
        <Plus className="h-4 w-4" />
        New conversation
      </Button>
      <div className="mt-2 w-full max-w-md">
        <div className="text-muted-foreground mb-2 text-xs font-medium tracking-wide uppercase">Try</div>
        <ul className="text-muted-foreground space-y-1 text-sm">
          {PROMPTS.map((p) => (
            <li key={p} className="bg-muted/30 rounded border px-3 py-2 text-left">
              {p}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
